import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface BackupsetDetailRowProps {
  label: string;
  value: ReactNode;
  /**
   * Background color for the row.
   */
  backgroundColor?: string;
  /**
   * When true, render the row in the \"highlighted\" style
   * (used for \"Backup Login Online\" and similar emphasis rows).
   */
  highlighted?: boolean;
  /**
   * Optional color override for the value text.
   */
  valueColor?: string;
  /**
   * When true, allow the value to wrap across multiple lines.
   */
  multiline?: boolean;
}

const BackupsetDetailRow = ({
  label,
  value,
  backgroundColor = 'transparent',
  highlighted = false,
  valueColor,
  multiline,
}: BackupsetDetailRowProps) => {
  const displayValue: ReactNode =
    value == null
      ? '-'
      : typeof value === 'object'
        ? JSON.stringify(value)
        : value;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '3px 10px',
        gap: '10px',
        backgroundColor,
        minHeight: highlighted ? '23px' : '24px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '11px',
          lineHeight: '16px',
          color: highlighted ? '#FFFFFF' : '#64748B',
          textTransform: highlighted ? 'capitalize' : 'none',
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '18px',
          color: highlighted ? '#FFFFFF' : valueColor || '#0F172A',
          textAlign: 'right',
          overflow: 'hidden',
          textOverflow: multiline ? 'unset' : 'ellipsis',
          whiteSpace: multiline ? 'pre-line' : 'nowrap',
          maxWidth: '65%',
        }}
      >
        {displayValue}
      </Typography>
    </Box>
  );
};

export default BackupsetDetailRow;

